module.exports = __webpack_public_path__ + "img/adidas-family.21422fe1.png";